module.exports = __webpack_public_path__ + "static/media/ic_info_icon_white.b23dc8e9.svg";